export function goalPreferencesBuilderForMilli(data) {
  if (!data || data.length === 0) {
    return {};
  }
  return data.reduce((map, obj) => {
    map[obj.SectionID] = !obj.IsHidden;
    return map;
  }, {});
}
